import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";

var PageItem = function PageItem(_ref) {
  var active = _ref.active,
      children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["active", "children", "href", "onClick"]);

  var getClassName = getClassNameFactory(PageItem.displayName);
  var InnerName = "span";
  var clickable = false;
  var innerProps = {};

  if (active) {
    innerProps["aria-current"] = "true";
    innerProps["aria-label"] = "Current Page, Page ".concat(children);
  } else if (href) {
    InnerName = "a";
    innerProps.href = href;
    innerProps["aria-current"] = "false";
    innerProps["aria-label"] = "Go to Page ".concat(children);
    clickable = true;
  } else if (onClick) {
    InnerName = "button";
    innerProps.onClick = onClick;
    clickable = true;
  }

  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: classNames({
        active: active
      })
    })
  }, /*#__PURE__*/React.createElement(InnerName, _extends({
    className: getClassName({
      descendantName: "inner",
      states: classNames({
        clickable: clickable
      })
    })
  }, innerProps, rest), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "innerText"
    })
  }, children)));
};

PageItem.displayName = "Pagination.PageItem";
PageItem.defaultProps = {
  active: false
};
export default PageItem;